import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from '@themesberg/react-bootstrap'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Wrapper } from './FreeSubscriptionComplete.styled'
import useSharedFunctions from '../../components/custom/Shared/SharedFunctions/SharedFunctions'
import useRequest from '../../axios/apis/useRequest'
import SafeFormatMessage from '../../components/custom/Shared/SafeFormatMessage/SafeFormatMessage'
import { UppercaseMonthDateFormat } from '../../lib/sharedFun/Time'

const FreeSubscriptionComplete = ({ priceData }) => {
  const { getLocalizedString } = useSharedFunctions()
  const [orderID, setOrderID] = useState('')
  const [orderData, setOrderData] = useState()
  const [email, setEmail] = useState('')

  const direction = useSelector((state) => state.main.direction)
  const hash = window.location.hash
  const array = hash.split('#')
  const orderIDHash = array.find((element) => element.includes('order-'))

  const { getOrderByIdPublic, completeFreeSubscription } = useRequest()

  useEffect(() => {
    if (!orderIDHash) {
      return
    }
    setOrderID(orderIDHash.replace('order-', ''))
  }, [orderIDHash])

  useEffect(() => {
    if (!orderID || orderData) {
      return
    }
    ;(async () => {
      const order = await getOrderByIdPublic(orderID)
      setOrderData(order.data.data)
    })()
  }, [orderID])

  const handleSubmit = async () => {
    if (!orderID || !email) {
      return
    }
    const response = await completeFreeSubscription({ orderID, email })
    const navigationUrl = response?.data.data.navigationUrl
    if (navigationUrl) {
      const decodedUrl = decodeURIComponent(navigationUrl)
      window.location.href = decodedUrl
    }
  }

  return (
    <Wrapper>
      {orderData?.orderItems && (
        <section
          className="d-flex align-items-center"
          style={{ minHeight: '100vh' }}
        >
          <Container className="d-flex justify-content-center">
            <Card
              style={{
                height: '50vh',
                backgroundColor: 'var(--themeBackground)',
              }}
              className="w-75"
            >
              <Card.Body className="d-flex justify-content-center w-100">
                <Row>
                  <Col
                    md={5}
                    className="d-flex align-items-center justify-content-center border-right-1 border-light"
                  >
                    <div>
                      <Card.Title className="mb-0">
                        <span
                          className="fw-bold"
                          style={{ color: 'var(--primary4)' }}
                        >
                          {priceData?.product?.displayNameLocalizations
                            ? getLocalizedString(
                                priceData?.product?.displayNameLocalizations
                              )
                            : priceData?.product?.displayName}
                        </span>
                        <div
                          style={{
                            color: 'var(--primary4)',
                            fontSize: 'var(--normalFont)',
                            fontWeight: 'normal',
                          }}
                        >
                          {/* <SafeFormatMessage id="Subscribe" />{' '} */}
                          <div className="fw-bold">
                            {orderData?.orderItems[0]?.displayName}
                          </div>
                        </div>
                        <div
                          className="fw-bold"
                          style={{
                            color: 'var(--second-color)',
                            fontSize: 'var(--hugeFont)',
                          }}
                        >
                          <SafeFormatMessage
                            id="Free-Subscription"
                            defaultMessage={'Free Subscription'}
                          />
                        </div>
                        <div
                          style={{
                            color: 'var(--primary4)',
                            fontSize: 'var(--normalFont)',
                            fontWeight: 'normal',
                          }}
                        >
                          {orderData?.orderItems[0]?.description}
                        </div>
                      </Card.Title>
                    </div>
                  </Col>
                  <Col
                    md={7}
                    className={`my-2 d-flex align-items-center justify-content-start  ${direction === 'ltr' ? 'pl-5' : 'pr-5'}`}
                  >
                    <div style={{ width: '100%' }}>
                      <Card.Title>
                        <SafeFormatMessage
                          id="Complete-your-free-subscription"
                          defaultMessage={'Complete your free subscription'}
                        />
                      </Card.Title>
                      <Form.Group controlId="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter your email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="mb-3"
                        />
                      </Form.Group>

                      <Card.Footer className="px-0 mb-0 h-100 d-flex justify-content-center">
                        <Button
                          variant="primary"
                          style={{
                            width: '100%',
                            padding: '10px',
                            fontSize: '16px',
                          }}
                          onClick={handleSubmit}
                        >
                          <SafeFormatMessage
                            id="Complete"
                            defaultMessage={'Complete'}
                          />
                        </Button>
                      </Card.Footer>
                      <div
                        className="copy"
                        style={{ color: 'var(--primary4)' }}
                      >
                        Powered by <span className="yellow">@</span>
                        <span className="fw-bold">RoSaaS</span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Container>
        </section>
      )}
    </Wrapper>
  )
}

export default FreeSubscriptionComplete
